import { UserRole } from '@/hooks/use-user-roles'
import { UserContext } from '@/providers/user-context'
import { useContext } from 'react'
import { Navigate } from 'react-router-dom'

export function RoleProtectedRoute({
  allowedRoles,
  children,
}: {
  allowedRoles: UserRole[]
  children: React.ReactNode
}) {
  const { roles } = useContext(UserContext)
  // Allow the user to access the page if they have no roles yet. This allows for page reloads to work.
  if (!roles) return <>{children}</>

  // Check if the user has any of the allowed roles
  if (roles.some((role) => allowedRoles.includes(role))) return <>{children}</>

  // No allowed role: block access - send to home page
  return <Navigate to='/' replace />
}
